<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>ECNs</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right bid">
                        <button  v-if="isAdmin || isSuperAdmin" @click="suspendAllEcns()" type="button" class="btn btn-danger mr-3"><i class="fas fa-trash-alt"></i> SUSPEND ALL</button>           
                        <button   @click="toggleMsrbImport()" type="button" class="btn btn-success  mr-3"><i class="fas fa-upload"></i> IMPORT MSRB</button>           
                        <!-- <button v-if="(isAdmin || isEditor)" :disabled="!settings.isSendToEcn" @click="reuploadAllEcns()" type="button" class="btn btn-warning mr-3"><i class="far fa-minus-square"></i> REUPLOAD ALL</button>           
                        <button v-if="isAdmin || isSuperAdmin" @click="killOperations()" type="button" class="btn btn-warning mr-3"><i class="far fa-minus-square"></i> KILL SWITCH</button>            -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl ecntbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >ECN</th> 
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >HEARTBEAT</th>                           
                                <th 
                                    scope="col" 
                                    class="sort"
                                   >COMP ID</th>
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="ecns.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                            </td>
                            </tr>
                            <tr v-for="ecn in ecns" :key="ecn.id" >
                                <td>
                                    <span class="text-primary">{{ecn.ecnId == 'TWD-BW' ? 'TWR-BW' : ecn.ecnId }}</span><br>
                                  
                                </td>
                                <td> 
                                    <span v-if="ecn.ecnId == 'KBP'" class="text-success">{{IBPHeartBeat ? moment(IBPHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                     
                                    <span v-if="ecn.ecnId == 'TMC-BW'" class="text-success">{{TMCHeartBeat ? moment(TMCHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                     
                                   
                                    <span v-if="ecn.ecnId == 'TWD-BW'" class="text-success">{{TWRHeartBeat ? moment(TWRHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                                   
                                    <span v-if="ecn.ecnId == 'TWD-ABW'" class="text-success">{{TWRHeartBeat ? moment(TWRHeartBeat).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</span>                                   
                                    
                                </td>

                                <td>
                                    <span v-if="ecn.ecnId == 'TWR'">TWR-EXE : </span><span>{{ecn.senderCompId}}</span>   
                                    <br>                                
                                    <span v-if="ecn.ecnId == 'TWR'">TWR-OFF : </span><span v-if="ecn.senderCompId2">{{ecn.senderCompId2}}</span>                                   
                                </td>

                            </tr>
                            </tbody>
                        </table>                      
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <MsrbImport 
            v-if="msrbModalOpen" 
            @close="toggleMsrbImport()" />
    </div>     
</template>
<script>
import authService from "@/authService";
import config from "@/config";
import MsrbImport from "./ImportMSRBModal.vue"
export default {
  name: "imsComponent",
  components : {
     MsrbImport
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        ecns : [],
        ecnEditModalOpen : false,
        ecnsHeartbeat : null,
        heartBeatShow : false,
        ecnHeartbeatApiCall : false,
        disabledReupload : true,
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        IBPHeartBeat : null,
        TMCHeartBeat : null,
        TWREXEHeartBeat : null,
        TWROFFHeartBeat : null,
        TWRHeartBeat : null,
        settings : {isSendToEcn : true},
        msrbModalOpen : false
     
    };
  },
  methods: {
    toggleMsrbImport(){
        this.msrbModalOpen = !this.msrbModalOpen
    },
    deleteAllBidWanted(){
        var message = "Are you sure you want to delete all bid wanted?";
        var postData = {
            
        };    
        this.$confirm(message,"Delete All Bid Wanted","warning",{confirmButtonText:"Delete All",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .put(
                config.baseUrlBidSide +
                    "/bidwanted/delete-all?cognitoSub="+authService.getUser().cognitoSub,postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Deletion in progress.","","success");
                })
            })
    },  
    getEcnHearbeatLiveData () {
		this.ecnHeartbeatApiCall = setInterval(() => {
			this.getEcnsHeartBeat();
		}, 10000)
	},
    openEcnEditModal(ecn){
        this.ecnData = {...ecn};
        this.ecnEditModalOpen = true
    },
    closeEcnEditModal(){
        this.ecnEditModalOpen = false
    },
    getEcns(){
        this.loading = true;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidWantedEcns/list?moduleName=AutoBidder",
            auth
        )
        .then(result => {
          this.ecns = result.data;
          let isAllEcnsSuspended = true;
          this.ecns.forEach(ecn => {
            if(!ecn.suspend){
                isAllEcnsSuspended = false;
            }
          });
          this.disabledReupload = !isAllEcnsSuspended;
          this.getEcnsHeartBeat();
          this.loading = false;
        })       
    },
    getEcnsHeartBeat(){
        this.getTWDStatus();
        this.getIBPStatus();  
        this.getTMCStatus();   
    },
    getTWDStatus(){
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=TWD-ABW",
            auth
        )
        .then(result => {
          this.TWRHeartBeat = result.data[0].date;
        //   this.TWREXEHeartBeat = result.data[1].date;
        })  
    },
    getIBPStatus(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=IBP",
            auth
        )
        .then(result => {
          this.IBPHeartBeat = result.data[0].date;
        })  
    },
    getTMCStatus(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/ecn/lastheartbeat?ecnType=TMC-BW",
            auth
        )
        .then(result => {
          this.TMCHeartBeat = result.data[0].date;
        })  
    },
    suspendAllEcns(){
        var message = "Are you sure you want to suspend All ecns?";
        var postData = {"ecns":["IBP","TMC","TWD"],"cognitoSub":authService.getUser().cognitoSub};    
        this.$confirm(message,"Suspend All Ecn","question",{confirmButtonText:"Suspend All",cancelButtonText : "No"}).then(() => {
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/suspend-all",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("ECN suspension in progress.","","success");
                this.getEcns();
                })
            })
    },
    suspendEcn(ecn){
        let encName;
        encName = ecn;
        if(ecn == 'TWR'){
            encName = "TWD";
        }
        if(ecn == 'KBP'){
            encName = "IBP";
        }
        var message = "Are you sure you want to suspend this ecn?";
        var postData = {"ecns":[encName],"cognitoSub":authService.getUser().cognitoSub};    

        this.$confirm(message,"Suspend Ecn","",{confirmButtonText:"Suspend",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/suspend-all-offer-to-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("ECN suspension in progress.","","success");
                this.getEcns();
                })
        })
    },
    reupload(ecn){
        let encName;
        encName = ecn;
        if(ecn == 'TWR'){
            encName = "TWD";
        }
        if(ecn == 'KBP'){
            encName = "IBP";
        }
        var message = "Are you sure you want to reupload suspended offers?";
        var postData = {"ecns":[encName],"cognitoSub":authService.getUser().cognitoSub};    

        this.$confirm(message,"Reupload Offers","",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/reupload-suspended-ecn-offers",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Reupload in progress.","","success");
                this.getEcns();
                })
        })
    },
    reuploadAllEcns(){
        var message = "Are you sure you want to reupload suspended offers?";
        var postData = {"ecns":["IBP","TMC","TWD","MKTX"],"cognitoSub":authService.getUser().cognitoSub};    
        this.$confirm(message,"Reupload Offers","",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/reupload-suspended-ecn-offers",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Reupload in progress.","","success");
                this.getEcns();
                })
        })
    },
    restartEcn(ecn){
        var message = "Are you sure you want to restart "+ecn+ "?";
        var postData = {          
            "restartTWD" : ecn == 'TWR' ? true :false,
            "restartTMC" : ecn == 'TMC' ? true :false,
            "restartIBP" : ecn == 'KBP' ? true :false,
            "cognitoSub" : authService.getUser().cognitoSub,
            "isSuspend"  : true
        };    

        this.$confirm(message,"Restart Ecn","",{confirmButtonText:"Restart",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/ecn/restart-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Restart Successfully.","","success");
                this.getEcns();
                })
        })
    },
    killOperations(){
        var message = "Are you sure you want to suspend all offerings to all the ecns and deactivate the ecns?";
        var postData = {"ecns":["TMC","TWD","IBP"],"cognitoSub":authService.getUser().cognitoSub}  

        this.$confirm(message,"Confirm","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
                .post(
                config.baseUrlBidSide +
                    "/offer/kill-ecn",postData,
                    auth
                )
                .then(() => {
                this.loading = false;
                this.$alert("Under process.","","success");
                this.getEcns();
                })
        })
    },
    startEcn(){
        var message = "Are you sure you want to start this ecn?";
        this.$confirm(message,"Start Ecn","",{confirmButtonText:"Start",cancelButtonText : "No"}).then(() => {})
    },
    getSettings(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;

        })        
    },
  },
  mounted() {
    this.getEcns();
  },
  beforeDestroy () {
	clearInterval(this.ecnHeartbeatApiCall)
  },
  created () {
	this.getEcnHearbeatLiveData();
    this.getSettings();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
         //console.log("curret role",this.isAdmin,this.isTrader,this.isEditor,this.isSuperAdmin);
    });
 }
};
</script>
